<template>
    <div class="orderTicketsList">
        <div class="table-responsive relative" @scroll="handleTableScroll($event)">
            <table ref="containerRef" class="table table-striped table-hover border order-tickets-table">
                <thead ref="theadRef">
                    <tr>
                        <th>Name</th>
                        <th class="print:hidden">&nbsp;</th>
                        <th>Order Type</th>
                        <th>Date Filled</th>
                        <th>Date Exited</th>
                        <th>P/L</th>
                        <th>Ticket</th>
                        <th class="print:hidden">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="ticketItem in tableData" :key="ticketItem.id">
                        <td>{{ ticketItem.market_name || '-' }}</td>
                        <td class="print:hidden">
                            <div class="float-left inline-block">
                                <button-group
                                    :symbol="ticketItem.symbol"
                                    :groups="buttons"
                                    :extra-data="ticketItem"
                                >
                                </button-group>
                            </div>
                        </td>
                        <td>{{ ticketItem.long_short == 'L' ?  'Long' : 'Short' }}</td>
                        <td>{{ ticketItem.entry_date || '-' }}</td>
                        <td>{{ ticketItem.exit_date || '-' }}</td>
                        <td>{{ toNumeric(ticketItem.profit_loss) }}</td>
                        <td>
                            <a @click="printTicket(ticketItem)" v-tooltip="{ content: 'Print Current Ticket', placement: 'auto-start', theme: 'info' }" class="inline-block cursor-pointer">
                                {{ ticketItem.ticket_number || '-' }}
                            </a>
                        </td>
                        <td class="print:hidden flex flex-nowrap justify-end">
                            <span @click="printTicket(ticketItem.id)" v-tooltip="{ content: 'Print Current Ticket', placement: 'auto-start', theme: 'info' }" class="inline-flex btn btn-shadow-none btn-blue-ghost btn-xs mr-1"><i class="fas fa-print"></i></span>
                            <span @click="editTicket(ticketItem.id)" v-tooltip="{ content: 'Edit Current Ticket', placement: 'auto-start', theme: 'info' }" class="inline-flex btn btn-shadow-none btn-blue-ghost btn-xs ml-1"><i class="far fa-edit"></i></span>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th>Name</th>
                        <th class="print:hidden">&nbsp;</th>
                        <th>Order Type</th>
                        <th>Date Filled</th>
                        <th>Date Exited</th>
                        <th>P/L</th>
                        <th class="order-tickets-table-center">Ticket</th>
                        <th class="print:hidden">Actions</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useStickyHeader } from '../../DataTable/mixins/StickTableHeader';

const props = defineProps({
    initTableData: Array,
    buttons: Array,
    section: String,
});

const { containerRef, theadRef, handleScroll, handleTableScroll, resizeHeader } = useStickyHeader();

const tableData = ref(props.initTableData);

function toNumeric(number, decimals = 2) {
    let value = number || 0;
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals).toFixed(decimals);
}

const printTicket = (ticketId) => {
    var route = window.route('my-folder.order-tickets.print', ticketId);
    var win = window.open(route, '_blank');
    win.focus();
};

const editTicket = (ticketId) => {
    window.location = window.route('my-folder.order-tickets.edit', ticketId);
};

onMounted(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', resizeHeader);
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('resize', resizeHeader);
});
</script>

<style lang="scss">
.orderTicketsList {
    .order-tickets-table {
        &.table {
            thead,
            tfoot {
                td, th {
                    @apply px-3 py-2;
                }
            }
            thead {
                tr {
                    @apply border-t;
                    td, th {
                    }
                }
            }
            tbody, tfoot {
                td, th {
                    @apply px-3 text-sm;
                }
            }

            .sortable {
                @apply cursor-pointer;
            }
        }
    }
}
</style>
